import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Protected from "../views/Protected.vue";
import Statistics from "../views/Statistics.vue";
import Clients from "../views/Clients.vue";
import OrganizationParameters from "../views/OrganizationParameters.vue";
import PurchaseData from "../views/PurchaseData.vue";
import ProductsTypes from "../views/ProductsTypes.vue";
import ProductsTypesTranslations from "../views/ProductsTypesTranslations.vue";
import ProductsTypesAlerts from "../views/ProductsTypesAlerts.vue";
import ProductsTypesRelations from "../views/ProductsTypesRelations.vue";
import ProductsTypesClients from "../views/ProductsTypesClients.vue";
import { DEFAULT_APPLICATION_ROLE } from "../plugins/keycloak.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: { isAuthenticated: true }
  },
  {
    path: "/protected",
    name: "protected",
    component: Protected,
    meta: { isAuthenticated: true }
  },
  {
    path: "/statistics",
    name: "statistics",
    component: Statistics,
    meta: { isAuthenticated: true }
  },
  {
    path: "/purchaseData",
    name: "purchaseData",
    component: PurchaseData,
    meta: { isAuthenticated: true }
  },
  {
    path: "/clients",
    name: "clients",
    component: Clients,
    meta: { isAuthenticated: true }
  },
  {
    path: "/organizationParameters",
    name: "organizationParameters",
    component: OrganizationParameters,
    meta: { isAuthenticated: true }
  },
  {
    path: "/productsTypes",
    name: "productsTypes",
    component: ProductsTypes,
    meta: { isAuthenticated: true }
  },
  {
    path: "/productsTypesTranslations",
    name: "productsTypesTranslations",
    props: route => ({
      productType: route.query.productType
    }),
    component: ProductsTypesTranslations,
    meta: { isAuthenticated: true }
  },
  {
    path: "/productsTypesAlerts",
    name: "productsTypesAlerts",
    props: route => ({
      productType: route.query.productType
    }),
    component: ProductsTypesAlerts,
    meta: { isAuthenticated: true }
  },
  {
    path: "/productsTypesRelations",
    name: "productsTypesRelations",
    props: route => ({
      productType: route.query.productType
    }),
    component: ProductsTypesRelations,
    meta: { isAuthenticated: true }
  },
  {
    path: "/productsTypesClients",
    name: "productsTypesClients",
    props: route => ({
      productType: route.query.productType
    }),
    component: ProductsTypesClients,
    meta: { isAuthenticated: true }
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.isAuthenticated) {
    // Get the actual url of the app, it's needed for Keycloak
    const basePath = window.location.toString();
    if (!Vue.$keycloak.authenticated) {
      // The page is protected and the user is not authenticated. Force a login.
      Vue.$keycloak.login({ redirectUri: basePath + to.path });
    } else if (Vue.$keycloak.hasResourceRole(DEFAULT_APPLICATION_ROLE)) {
      // The user was authenticated, and has the app role (is authorized). Update the token.
      Vue.$keycloak
        .updateToken(40)
        .then(() => {
          next();
        })
        .catch(err => {
          console.error(err);
        });
    } else {
      // The user was authenticated, but did not have the correct role (is not authorized)
      // Redirect the user to an error page
      Vue.$keycloak.logout();
    }
  } else {
    // This page did not require authentication
    next();
  }
});

export default router;
